import {CATEGORY_SEARCH, KEYWORD_SEARCH} from "@next/utils"
import State from "../../../models/State"
import {SearchApiRequestTypes, LANGUAGE_HEADER} from "../../../config/constants"
import {selectSelectedFilterNames} from "../../selectSelectedFilterNames"
import {selectRealm, selectTerritory} from "../../../ducks/request"
import {joinArrayBasedOnLanguage} from "../../joinArrayBasedOnLanguage"
import updateGender from "../updateGender"

export function selectSeoMetadataArgs(state: State) {
    const {
        request: {type, category, gender, territoryName, headers},
        search: {title},
        sale: {isSalePage, saleDisplayText},
        text,
    } = state
    const realm = selectRealm(state)
    const territory = selectTerritory(state)
    const isKeywordSearch = type === SearchApiRequestTypes.Keyword
    const market = territoryName
    const searchType = isKeywordSearch ? KEYWORD_SEARCH : CATEGORY_SEARCH
    let filters = selectSelectedFilterNames(state).join(" ")
    const withFilters = Boolean(filters.length)

    let searchTerm = ""
    if (searchType === KEYWORD_SEARCH) {
        searchTerm = title
        return {realm, territory, searchTerm, market, searchType, filters, withFilters}
    }
    if (!gender && !category) {
        searchTerm = title
        return {realm, territory, searchTerm, market, searchType, filters, withFilters}
    }

    // Category Pages
    // With Filters the template reads {filters} {searchTerm}
    // We need the order to be (Sale Gender Selected Filters) into {filters} (Categories) into {searchTerm}
    if (withFilters) {
        const filterParams: string[] = []
        if (isSalePage && saleDisplayText) {
            filterParams.push(saleDisplayText)
        }
        if (gender) {
            const transformedGender = updateGender(gender, headers[LANGUAGE_HEADER], text)
            filterParams.push(transformedGender)
        }
        filterParams.push(filters)
        filters = joinArrayBasedOnLanguage(headers[LANGUAGE_HEADER], filterParams)
        if (category && category.length > 0) {
            searchTerm = joinArrayBasedOnLanguage(headers[LANGUAGE_HEADER], category)
        }
    } else {
        // Without Filters the template reads {searchTerm}
        // We need the order to be (Sale Gender Categories) into {searchTerm}
        const filterParams: string[] = []
        if (isSalePage && saleDisplayText) {
            filterParams.push(saleDisplayText)
        }
        if (gender) {
            const transformedGender = updateGender(gender, headers[LANGUAGE_HEADER], text)
            filterParams.push(transformedGender)
        }
        if (category && category.length > 0) {
            filterParams.push(...category)
        }
        searchTerm = joinArrayBasedOnLanguage(headers[LANGUAGE_HEADER], filterParams)
    }

    return {realm, territory, searchTerm, market, searchType, filters, withFilters}
}
